<template>
  <layout title="Classrooms">
    <h4>Classroom Sessions</h4>
    <hr />
    <div class="row">
      <div v-for="session in sessions.data" :key="session.id" class="col-md-3">
        <div class="card shadow shadow-xs p-3">
          <h5>{{ session.date }}</h5>
          Start: {{ session.start_datetime.replaceAll("-", "/") + " GMT+0530" }}
          <br />
          End: {{ session.end_datetime.replaceAll("-", "/") + " GMT+0530" }}
          <button disabled class="mt-3 btn btn-sm btn-outline-primary">
            Join Session
          </button>
        </div>
      </div>
    </div>
  </layout>
</template>

<script>
import AppLayout from "../../Layouts/AppLayout";
import ClassroomLayout from "../../Layouts/ClassroomLayout";

export default {
  layout: [AppLayout, ClassroomLayout],
  props: {
    classroom: Object,
    sessions: Object,
    flash: Object,
  },
  data() {},
  methods: {},
};
</script>